module.exports = __webpack_public_path__ + "img/noMsgIcon.8f773b06.png";